module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "maintoc"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog004#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog005#epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog007#ch01"
    }
  }, [_vm._v("Mad Dog & Englishman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog009#acknow"
    }
  }, [_vm._v("Afterword/Acknowledgment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog010#moreauth"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/pppmaddog011#contactus"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4120192","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-maddog006.vue
// module id = 72
// module chunks = 0